import React, { useEffect, useState } from "react";
import "./Feestructure.css";
import axios from "axios";
import { resources } from "../Resourses/Resources";

const Feestructure = () => {
  const [feeData, setFeeData] = useState([]);
  const [academicyear, setAcademicYear] = useState("");

  const durationMap = {
    DIPLOMA: "3 Years",
    "UG": "4 Years",
    "PG": "2 Years",
  };
  const levelLabels = {
    DIPLOMA: "Diploma",
    UG: "UG",
    PG: "PG",
  };
  const order = ["DIPLOMA", "UG", "PG"];
  const getCurrentAcademicYear = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = today.getMonth() + 1; // (0 = Jan, so +1)

    // Academic year starts in June (example: 2024-2025)
    if (month >= 6) {
      return `${year}-${year + 1}`;
    } else {
      return `${year - 1}-${year}`;
    }
  };

  const fetchData = async (year) => {
    try {
      const response = await axios.get(
        resources.APPLICATION_URL + "getfeedata/Academicyear",
        {
          params: { academicyear: year },
        }
      );
      setFeeData(response.data);
    } catch (error) {
      console.error("Error fetching fee structure:", error);
    }
  };

  useEffect(() => {
    const currentYear = getCurrentAcademicYear();
    setAcademicYear(currentYear);
    fetchData(currentYear);
  }, []);

  return (
    <div>

      <div
        className="navbar navbar-expand-lg navbar-dark"
        style={{ backgroundColor: "#1E3A8A" }}
      >
        <div className="container">
          <a className="navbar-brand" href="#">
            Fee Structure
          </a>
        </div>
      </div>

      <br />

      <div className="main_division_of_fee">
        {order.map((lvl) => {
          const fee = feeData.find(
            (item) => item.feeStructurePrimaryKey.level.toUpperCase() === lvl
          );

          if (!fee) return null;

          const duration = durationMap[lvl] || "Duration Not Available";

          return (
            <div key={lvl} className="fee_card">
              <div className="fee_card_header">{levelLabels[lvl]}</div>
              <div className="fee_card_body">Duration: {duration}</div>

              <div className="fee_card_body_dash">Counselling</div>
              <div className="fee_card_fee">₹{fee.amount} / Year</div>

              <div className="fee_card_body_dash">NRI/Management</div>
              <div className="fee_card_fee">₹{fee.amount} / Year</div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Feestructure;
